﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { ListasValoresItems } from "../ListasValoresItems/ListasValoresItems";

const columns = () =>
(
    {
        c_listavalores_id: new EntityColumn<string>({ name: 'c_listavalores_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Lista de valores ID' }),
        vc_nombrelista: new EntityColumn<string>({ name: 'vc_nombrelista', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        vc_items: new EntityColumn<string[]>({ name: 'vc_items', type: 'varchar', flags: c.Edit, prompt: 'Items de la lista de valores ', isArray: true }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        liva_brwStandard: { name: 'liva_brwStandard', keyMappings: { c_listavalores_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'ListasValoresItems': {
            name: 'ListasValoresItems',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new ListasValoresItems(client, parentKeys)
        }
    }
)

export class ListasValoresDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('ListasValores');
    }
}